import React, { Component } from 'react'
import { connect } from 'react-redux'
import { NavSide } from '../../components'
import { SpecializedMaterialsForm, SpecializedMaterialsGallery } from './index'
import './styles.scss'

class SpecializedMaterials extends Component {

  render() {
    return (
      <div className='specialized-materials page-bg'>
        <div className='container-full'>

          <div className='content'>
            <div className='row'>
              <div className='col col-materials-gallery'>

                <div className='materials-gallery-box'>
                  <div>
                    <h3>Вход за специализирани материали</h3>
                  </div>
                  <div>
                    <SpecializedMaterialsGallery />
                  </div>
                </div>

              </div>
              <div className='col col-form-materials-contact'>

                <SpecializedMaterialsForm />

              </div>
            </div>
          </div>

        </div>

        <NavSide />

      </div>

    )
  }
}

export default connect()(SpecializedMaterials)
